import { Box, Button, Container } from "@mui/material";
import WelcomeNav from "../../components/TopNavBaru/WelcomeNav";
import TitleSection from "../../components/TitleSection";
import TemplatePenunjang from "./Templates/TemplatePenunjang";
import RencanaKontrol from "./Templates/RencanaKontrol";
import { connect } from "react-redux";
import { openResumeMedis } from "../../redux/actions/history";
import { useParams } from "react-router-dom";
import ModalWelcome from "../AntrianPage/Components/ModalWelcome";
import React from "react";
import ReviewDialog from "../../components/ReviewDialog";
import { checkReview } from "../../redux/actions/review";

type Props = {
  pasien: any;
  actOpenResumeMedis: ({ rkun_id }: any) => void;
  actCheckReview: Function;
};

const HistoryDetailPage = (props: Props) => {
  const { actOpenResumeMedis, actCheckReview, pasien } = props;
  const { id } = useParams();

  const [modals, setModals] = React.useState({
    welcome: false,
    review: false,
  });

  React.useEffect(() => {
    if (id) {
      actCheckReview(
        {
          rkun_id: id,
          ps_id: pasien?.id,
        },
        () => {
          setModals((prev) => ({ ...prev, review: true }));
        }
      );
    }
  }, [id, pasien?.id, actCheckReview]);

  return (
    <>
      <ModalWelcome
        open={modals.welcome}
        setOpen={(val: boolean) =>
          setModals((prev) => ({ ...prev, welcome: val }))
        }
      />
      <ReviewDialog
        setOpen={(val: boolean) =>
          setModals((prev) => ({ ...prev, review: val }))
        }
        open={modals.review}
        rkunId={id}
      />

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      >
        <WelcomeNav />
      </Box>
      <Box height="35vh"></Box>
      <TitleSection
        title="Rencana Kontrol"
        subtitle="daftar rencana kontrol berikutnya"
      />
      <RencanaKontrol />

      <TitleSection
        title="Penunjang"
        subtitle="riwayat penunjang pada perawatan saat ini"
      />
      <TemplatePenunjang />
      <Box height={"16vh"}></Box>
      <Box
        zIndex={99}
        padding="16px 16px"
        sx={{
          backgroundColor: "#FFF",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Container maxWidth="xs">
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={() => actOpenResumeMedis({ rkun_id: id })}
            // disabled={handleButton(detail).disabled}
            // onClick={() => setOpen(true)}
          >
            LIHAT RESUME MEDIS
          </Button>
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pasien: state.antrian.detail?.pasien,
    // stateRencanaKontrol: state.history.rencana_kontrol,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actOpenResumeMedis: ({ rkun_id }: any) =>
      dispatch(openResumeMedis({ rkun_id })),
    actCheckReview: (body: any, succ: Function) =>
      dispatch(checkReview(body, succ)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryDetailPage);
